const fiMessages = {
  /* 01.General */
  "chat.end": "Aloita chat-keskustelu uudelleen",
  "chat.endall": "Lopeta keskustelu",
  "chat.cancel": "Peruuttaa",
  "chat.cookie":
    "Tämä digitaalinen avustaja käyttää evästeitä varmistaakseen, että saat parhaan käyttökokemuksen",
  "chat.learn": "Lue lisää",
  "chat.minimize": "Minimoida",
  "chat.hide": "kiinni",
  "chat.hidebot.text": "Sulje poistaa avatarin 15 minuutiksi",
  "chat.hidebot": "Sulje (Piilota) Avatar",
  "chat.restart": "Uudelleenkäynnistää",
  "switch.language": "Vaihda kieltä",
  "switch.property": "Vaihda omaisuutta",
  "restart.converstation": "Aloita keskustelu uudelleen",
  "chat.endtext": "Haluatko varmasti lopettaa nykyisen keskustelun?",
  "check.availabity": "Tarkista saatavuus",
  "check.availabity.submit": "Lähetä",
  "check.availabity.cancel": "Peruuttaa",
  "check.availabity.adults": "Aikuiset ",
  "check.availabity.children": "Lapset",
  "check.availabity.child.age": "Ikä - lapsi",
  "feedback.leave": "Jätä palautetta",
  "feedback.leave.message": "Jätä viesti",
  "placeholder.name": "Name",
  "placeholder.firstName": "First Name",
  "placeholder.lastName": "Last Name",
  "placeholder.email": " Email",
  "placeholder.phoneNumber": "Phone Number",
  "placeholder.zipcode": "Zip Code",
  "caseform.title": "Lähetä tapaus",
  "caseform.system": "Järjestelmä",
  "caseform.loading.systems": "Ladataan järjestelmiä...",
  "caseform.select.system": "Valitse järjestelmä",
  "caseform.error.systems": "Virhe järjestelmien lataamisessa",
  "caseform.scenario": "Skenaario",
  "caseform.loading.scenarios": "Ladataan skenaarioita...",
  "caseform.select.scenario": "Valitse skenaario",
  "caseform.error.scenarios": "Virhe skenaarioiden lataamisessa",
  "caseform.topic": "Aihe",
  "caseform.loading.topics": "Ladataan aiheita...",
  "caseform.select.topic": "Valitse aihe",
  "caseform.error.topics": "Virhe aiheiden lataamisessa",
  "caseform.productArea": "Product Areas",
  "caseform.loading.productAreas": "Loading product areas...",
  "caseform.select.productArea": "Select Product Area",
  "caseform.error.productAreas": "Error loading product areas",
  "caseform.module": "Modules",
  "caseform.loading.modules": "Loading modules...",
  "caseform.select.module": "Select Module",
  "caseform.error.modules": "Error loading modules",
  "caseform.feature": "Features",
  "caseform.loading.features": "Loading features...",
  "caseform.select.feature": "Select Feature",
  "caseform.error.features": "Error loading features",
  "caseform.subject": "Aihe",
  "caseform.description": "Kuvaus",
  "caseform.attachments": "Liitteet",
  "caseform.attachments.remove": "Poista",
  "caseform.submit": "Lähetä",
  "caseform.cancel": "Peruuta",
  "caseform.success.title": "Tapaus luotu",
  "caseform.success.message": "Tapauksesi on luotu onnistuneesti.",
  "caseform.success.caseNumber": "Tapausnumero:",
  "caseform.success.transferToLiveAgent": "Sinut siirretään live-agentille.",
  "caseform.success.newChatWindowRightSide":
    "Uusi chat-ikkuna avautuu selaimesi oikealle puolelle.",
  "caseform.success.ok": "OK",
  "simpleaction.title": "Valitse toiminto",
  "simpleaction.body":
    "Valitse yksi seuraavista vaihtoehdoista:{br}{b}Luo tapaus{/b} lähettää tukipyyntö, tai {b}Aloita chat{/b} yhdistääksesi agenttiin nyt.",
  "simpleaction.startchat": "Aloita chat",
  "simpleaction.createcase": "Luo tapaus",
  "caseform.error.generic": "Virhe tapauksen luomisessa.",
  "caseform.error.generic.message":
    "Tapahtui virhe tapauksen luomisessa. Yritä uudelleen myöhemmin.",
};
export default fiMessages;
